import { colors } from '@insurancemenu/imenu-components-lib';
import NoDataPlaceholder from 'components/common/general/NoDataPlaceholder';
import styled from 'styled-components';

export const NoDataPlaceholderStyled = styled(NoDataPlaceholder)`
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  box-sizing: border-box;
  padding: 5rem 4rem;
`;
